/**
 * 成長系統首頁 URL（白名單：僅 VITE_GROWTH_SYSTEM_URL）
 */

export function resolveGrowthSystemHomeUrl(raw) {
    const value = String(raw || '').trim();
    if (!value) return '';
    try {
        const withProto = /^https?:\/\//i.test(value) ? value : `https://${value}`;
        const u = new URL(withProto);
        if (u.protocol !== 'http:' && u.protocol !== 'https:') return '';
        const path = u.pathname === '/' ? '' : u.pathname.replace(/\/$/, '');
        return `${u.origin}${path}`;
    } catch {
        return '';
    }
}

export function goToGrowthSystemHome(rawEnvUrl) {
    const home = resolveGrowthSystemHomeUrl(rawEnvUrl);
    if (!home || typeof window === 'undefined') return false;
    window.location.assign(home);
    return true;
}

/**
 * 成長系統 SSO 中轉（世界樹驗證）→ 後台諮詢工作台
 * target=balance_sheet_admin
 */
export function resolveGrowthAdminSsoBridgeUrl(rawEnvUrl) {
    const home = resolveGrowthSystemHomeUrl(rawEnvUrl);
    if (!home) return '';
    if (home.includes('/sso-bridge')) return home;
    return `${home.replace(/\/$/, '')}/sso-bridge?target=balance_sheet_admin`;
}

export function goToGrowthAdminSso(rawEnvUrl) {
    const url = resolveGrowthAdminSsoBridgeUrl(rawEnvUrl);
    if (!url || typeof window === 'undefined') return false;
    window.location.assign(url);
    return true;
}
